import React from "react";
import { StandardCloseButton } from "./StandardCloseButton.style";

interface Props {
  onClick: () => any | string;
}

export default StandardCloseButton;
